exports = module.exports = require("../../../../../../../../../css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".options{display:flex;justify-content:center;align-items:center;margin-top:px}.options>*{margin:5px}", "",{"version":3,"sources":["styles.scss"],"names":[],"mappings":"AACA,SACE,YAAA,CACA,sBAAA,CACA,kBAAA,CAEA,aAAA,CAEA,WACE,UAAA","file":"styles.scss","sourcesContent":["$theme: zam;\n.options {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  margin-top: px;\n\n  > * {\n    margin: 5px;\n  }\n}\n"]}]);

// Exports
exports.locals = {
	"options": "options"
};